import React, { useRef, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import RadioButtonCheckedRoundedIcon from "@material-ui/icons/RadioButtonCheckedRounded";
import RadioButtonUncheckedRoundedIcon from "@material-ui/icons/RadioButtonUncheckedRounded";
import { ThemeProvider } from "@material-ui/core";
import { vars } from "../../config/theme";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { editButtonTheme } from "../../config/theme";
import { ASC, DESC, sortableFields, namesForIndicator } from "../../lib/data";
import {
    renderSortArrow,
    buttonHeaders,
    addButtons,
} from "../../lib/helperFuncs.jsx";
import OrderChangeComponent from "../OrderChangeComponent/OrderChangeComponent.jsx";
import moment from "moment";
import { useModal } from "../../../ModalContext.jsx";
import styles from "./ItemsList.module.css";
import Tooltip from "@material-ui/core/Tooltip";

const getButtonProps = (props) => {
    const {
        removeAction,
        editAction,
        toggleAction,
        viewAction,
        loadExcelAction,
        selectHotelAction,
        setDirectLink,
    } = {
        ...props,
    };
    return {
        removeAction,
        editAction,
        toggleAction,
        viewAction,
        loadExcelAction,
        selectHotelAction,
        setDirectLink,
    };
};

const getListButtons = (listButtons, id) => {
    if (!Array.isArray(listButtons)) return [];
    return listButtons.map((button, index) => (
        <TableCell align="left" key={`list_${index}_${id}`}>
            <ThemeProvider theme={editButtonTheme}>
                <Button
                    component={Link}
                    variant="outlined"
                    color="primary"
                    startIcon={button.icon}
                    to={button.link(id)}
                >
                    {button.caption}
                </Button>
            </ThemeProvider>
        </TableCell>
    ));
};

const ItemsList = (props) => {
    const { showModal } = useModal();

    const lastItem = useRef(null);
    const sortItems = (params, moreParams) => {
        const sortParams = { ...params };
        const { sortField } = { ...sortParams };
        if (!sortableFields.includes(sortField) || props.loadExcelAction)
            return undefined;

        sortParams.sortOrder = props.sortOrder;

        if (props.sortField) {
            switch (sortParams.sortOrder) {
                case ASC:
                    sortParams.sortOrder = DESC;
                    break;
                case DESC:
                    sortParams.sortOrder = ASC;
                    break;
            }
        }

        if (props?.thisMessageLogs) {
            props.updateGlobalSearch(
                {
                    ...props.globalSearch.search.message_logs,
                    sortOrder: sortParams.sortOrder,
                    sortField,
                },
                "message_logs",
            );
        }

        if (moreParams) {
            sortParams.type = props.moreParams;
        }
        return props.sortAction(sortParams);
    };

    const buttonProps = getButtonProps(props);
    const tableHeaders = Object.keys(props.columns).map((colKey) => (
        <TableCell
            key={colKey}
            onClick={() => {
                sortItems(
                    { sortField: colKey, sortOrder: props.sortOrder },
                    props.moreParams,
                );
            }}
        >
            <>
                {props.columns[colKey]}
                {renderSortArrow(props.sortField, props.sortOrder, colKey)}
            </>
        </TableCell>
    ));
    const listItemsButtonHeaders = Array.isArray(props.listButtons)
        ? props.listButtons.map((button) => (
              <TableCell key={button.header}>{button.header}</TableCell>
          ))
        : [];
    // const listItemsButtons = Array.isArray(props.listButtons)
    //     ? props.listButtons.map(button => (
    //           <TableCell key={button.header}>{button.header}</TableCell>
    //       ))
    //     : [];

    const renderItems = (item, propName) => {
        if (namesForIndicator.includes(propName)) {
            if (item[propName] == 1) {
                return (
                    <RadioButtonCheckedRoundedIcon
                        style={{ color: vars.active }}
                    />
                );
            }
            return (
                <RadioButtonUncheckedRoundedIcon
                    style={{ color: vars.inactive }}
                />
            );
        } else if (propName === "type") {
            return props.fields.type.values[item.type];
        } else if (propName === "order") {
            return (
                <OrderChangeComponent
                    item={item}
                    updateParticularItem={props.updateParticularItem}
                />
            );
        } else if (propName === "date_residence") {
            return `${moment(item?.date_start).format("DD.MM.YYYY")} - ${moment(item?.date_end).format("DD.MM.YYYY")}`;
        } else if (propName === "date_booking") {
            if (item.date_start_booking || item.date_end_booking) {
                return `${moment(item.date_start_booking).format("DD.MM.YYYY HH:mm:ss")} - ${moment(item.date_end_booking).format("DD.MM.YYYY HH:mm:ss")}`;
            } else return "- - -";
        } else if (propName === "created_at") {
            return moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss");
        } else if (propName === "updated_at") {
            return moment(item?.updated_at).format("YYYY-MM-DD HH:mm:ss");
        } else if (propName === "request" && item?.[propName]) {
            return (
                <Button
                    className={styles.button__req__res}
                    onClick={() => showModal(item[propName])}
                >
                    Запрос
                    <span className={styles.button__icon}>{requestIcon}</span>
                </Button>
            );
        } else if (propName === "response" && item?.[propName]) {
            return (
                <Button
                    className={styles.button__req__res}
                    onClick={() => showModal(item[propName])}
                >
                    Ответ
                    <span className={styles.button__icon}>{responseIcon}</span>
                </Button>
            );
        } else if (propName === "entity_id" && item?.[propName]) {
            return (
                <>
                    {item.entity_id}
                    <Button
                        component={Link}
                        className={styles.render__reservation}
                        to={`/hotels/${props.hotelId}/reservations/${item.entity_id}/edit`}
                    >
                        <span>{renderReservationIcon}</span>
                    </Button>
                </>
            );
        } else if (propName === 'comment' && props?.thisPurchasedServices) {
            return (
                <tr>
                    <td style={{
                        maxWidth: '400px',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal'
                    }}>
                        {item?.comment}
                    </td>
                </tr>
            );
        }
        if (propName === "status" && item[propName] === "success_error") {
            return (
                <Tooltip
                    title={
                        "Не получен id от PMS, обновление брони в PMS не возможно"
                    }
                >
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 286.054 286.054"
                        xmlSpace="preserve"
                        style={{
                            enableBackground: "new 0 0 286.054 286.054",
                            width: "35px",
                        }}
                    >
                        <g>
                            <path
                                style={{ fill: "#E2574C" }}
                                d="M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027 c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236 c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209 S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972 c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723 c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843 C160.878,195.732,152.878,187.723,143.036,187.723z"
                            />
                        </g>
                    </svg>
                </Tooltip>
            );
        }
        return item[propName];
    };

    const tableFields = (item) => {
        return Object.keys(props.columns).map((propName) => (
            <TableCell key={propName}>{renderItems(item, propName)}</TableCell>
        ));
    };

    useEffect(() => {
        function scrollHelperFn() {
            props.scrollFn(
                lastItem.current,
                props.items[props?.items?.length - 1]?.id,
            );
        }

        window.addEventListener("scroll", scrollHelperFn);
        return () => window.removeEventListener("scroll", scrollHelperFn);
    }, [props.items]);

    let shouldButtonHeaders = !props?.thisMessageLogs;

    if (props?.thisMessageLogs) {
        shouldButtonHeaders = props.items.some(
            (item) => item.may_deleted === true,
        );
    }

    return (
        <TableContainer>
            <Table aria-label="customized table">
                <TableHead>
                    <TableRow>
                        {tableHeaders}
                        {listItemsButtonHeaders}
                        {shouldButtonHeaders && [...buttonHeaders(props)]}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.items.map((item, index) => {
                        const listButtons = getListButtons(
                            props.listButtons,
                            item.id,
                        );

                        const buttons = addButtons({
                            ...buttonProps,
                            active: !!parseInt(item.active),
                            id: item.id,
                            item: item,
                            name: props?.thisMessageLogs
                                ? "запись журнала id = " + item.id
                                : item.name,
                            modelName: props.modelName,
                            needViewCopyButton: props?.needViewCopyButton,
                            copyObject: props.copyObject,
                            may_deleted: item?.may_deleted,
                            thisPurchasedServices: props?.thisPurchasedServices,
                            thisManteraExport: props?.thisManteraExport,
                        });
                        if (index === props?.items?.length - 1) {
                            return (
                                <TableRow key={index} hover ref={lastItem}>
                                    {tableFields(item)}
                                    {listButtons}
                                    {
                                        (
                                            (shouldButtonHeaders && !props?.thisRefund) ||
                                            (shouldButtonHeaders && props?.thisRefund && !item.notEdit)
                                        ) && buttons
                                    }
                                </TableRow>
                            );
                        }

                        return (
                            <TableRow
                                className={styles.hover__custom}
                                key={index}
                            >
                                {tableFields(item)}
                                {listButtons}
                                {
                                    (
                                        (shouldButtonHeaders && !props?.thisRefund) ||
                                        (shouldButtonHeaders && props?.thisRefund && !item.notEdit)
                                    ) && buttons
                                }
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

ItemsList.defaultProps = {};

ItemsList.propTypes = {
    setSortOrder: PropTypes.func,
    setSortField: PropTypes.func,
    sortAction: PropTypes.func,
    sortOrder: PropTypes.string,
    sortField: PropTypes.string,
    fields: PropTypes.object,
    modelName: PropTypes.string,
    moreParams: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    items: PropTypes.array.isRequired,
    columns: PropTypes.object.isRequired,
    toggleAction: PropTypes.func,
    loadExcelAction: PropTypes.func,
    viewAction: PropTypes.func,
    editAction: PropTypes.func,
    removeAction: PropTypes.func,
    listButtons: PropTypes.array,
    selectHotelIdAction: PropTypes.func,
    updateParticularItem: PropTypes.func,
    scrollFn: PropTypes.func,
};

export default ItemsList;

const requestIcon = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 5H6C5.46957 5 4.96086 5.21071 4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V18.5M8 5C8 5.53043 8.21071 6.03914 8.58579 6.41421C8.96086 6.78929 9.46957 7 10 7H12C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5M8 5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H12C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5M14 5H16C16.5304 5 17.0391 5.21071 17.4142 5.58579C17.7893 5.96086 18 6.46957 18 7V7.5"
            stroke="#1F1F1F"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M19 11L21 13L19 15M13 15L11 13L13 11M16.75 10L16.5 11L16 13L15.5 15L15.25 16"
            stroke="#1F1F1F"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

const responseIcon = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 5H6C5.46957 5 4.96086 5.21071 4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V18.5M8 5C8 5.53043 8.21071 6.03914 8.58579 6.41421C8.96086 6.78929 9.46957 7 10 7H12C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5M8 5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H12C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5M14 5H16C16.5304 5 17.0391 5.21071 17.4142 5.58579C17.7893 5.96086 18 6.46957 18 7V7.5"
            stroke="#1F1F1F"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11 12H16C17.0609 12 18.0783 12.4214 18.8284 13.1716C19.5786 13.9217 20 14.9391 20 16V17M11 12L14 15M11 12L14 9"
            stroke="#1F1F1F"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

const renderReservationIcon = (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M18.97 22.75H4.96997C1.21997 22.75 1.21997 20.67 1.21997 19V18C1.21997 17.04 2.00997 16.25 2.96997 16.25H20.97C21.93 16.25 22.72 17.04 22.72 18V19C22.72 20.67 22.72 22.75 18.97 22.75ZM2.96997 17.75C2.82997 17.75 2.71997 17.86 2.71997 18V19C2.71997 20.64 2.71997 21.25 4.96997 21.25H18.97C21.22 21.25 21.22 20.64 21.22 19V18C21.22 17.86 21.11 17.75 20.97 17.75H2.96997Z" fill="black"/><path d="M20.72 17.75H3.27002C2.86002 17.75 2.52002 17.41 2.52002 17V13C2.52002 8.9 5.43002 5.3 9.43002 4.45C10.02 4.32 10.64 4.25 11.27 4.25H12.72C13.36 4.25 13.98 4.32 14.57 4.45C18.57 5.31 21.47 8.91 21.47 13V17C21.47 17.41 21.14 17.75 20.72 17.75ZM4.02002 16.25H19.97V13C19.97 9.61 17.57 6.63 14.25 5.91C13.76 5.8 13.25 5.75 12.72 5.75H11.27C10.75 5.75 10.24 5.8 9.75002 5.91C6.43002 6.62 4.02002 9.6 4.02002 13V16.25Z" fill="black"/><path d="M9.59 5.93C9.26 5.93 8.96 5.71 8.87 5.38C8.79 5.09 8.75 4.8 8.75 4.5C8.75 2.71 10.21 1.25 12 1.25C13.79 1.25 15.25 2.71 15.25 4.5C15.25 4.8 15.21 5.09 15.13 5.38C15.03 5.76 14.65 6 14.25 5.91C13.76 5.8 13.25 5.75 12.72 5.75H11.27C10.75 5.75 10.24 5.8 9.75 5.91C9.7 5.92 9.65 5.93 9.59 5.93ZM11.27 4.25H12.72C13.06 4.25 13.41 4.27 13.74 4.31C13.65 3.43 12.9 2.75 12 2.75C11.1 2.75 10.36 3.43 10.26 4.31C10.6 4.27 10.93 4.25 11.27 4.25Z" fill="black"/><path d="M15 11.75H9C8.59 11.75 8.25 11.41 8.25 11C8.25 10.59 8.59 10.25 9 10.25H15C15.41 10.25 15.75 10.59 15.75 11C15.75 11.41 15.41 11.75 15 11.75Z" fill="black"/></svg>
)
